import { render, staticRenderFns } from "./BookingBill.vue?vue&type=template&id=3bfe4a54"
import script from "./BookingBill.vue?vue&type=script&lang=js"
export * from "./BookingBill.vue?vue&type=script&lang=js"
import style0 from "./BookingBill.vue?vue&type=style&index=0&id=3bfe4a54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports